import { z } from "zod";
import { StudioProjectModeV1Schema } from "./external-site-proof.js";
import { EnreinArtifactUriSchema } from "./artifact-uri.js";
import { NamedExternalArtifactBuilderIdV1Schema, } from "./artifact-registry-ids.js";
export { NamedExternalArtifactBuilderIdV1Schema, } from "./artifact-registry-ids.js";
export const ArtifactBuilderKindV1Schema = z.discriminatedUnion("kind", [
    z.object({ kind: z.literal("ENREIN_GENERATE") }).strict(),
    z
        .object({
        kind: z.literal("NAMED_EXTERNAL"),
        builderId: NamedExternalArtifactBuilderIdV1Schema,
    })
        .strict(),
]);
export const PerArtifactBuilderDeclarationV1Schema = z
    .object({
    schemaId: z.literal("artifact.builderDeclaration.v1"),
    artifactName: z.string().min(1),
    builder: ArtifactBuilderKindV1Schema,
})
    .strict();
const PROJECT_MODE_DEFAULT_EXTERNAL_BUILDER = {
    EXISTING_SITE_SCAN: "existing_site_scan",
    EXTERNAL_PROOF_ONLY: "external_proof_import",
};
/** Default per-artifact builder from project mode when no explicit override exists. */
export function defaultPerArtifactBuilderDeclaration(projectMode, artifactName) {
    if (projectMode === "DEFAULT_GENERATION") {
        return PerArtifactBuilderDeclarationV1Schema.parse({
            schemaId: "artifact.builderDeclaration.v1",
            artifactName,
            builder: { kind: "ENREIN_GENERATE" },
        });
    }
    const builderId = PROJECT_MODE_DEFAULT_EXTERNAL_BUILDER[projectMode];
    return PerArtifactBuilderDeclarationV1Schema.parse({
        schemaId: "artifact.builderDeclaration.v1",
        artifactName,
        builder: { kind: "NAMED_EXTERNAL", builderId },
    });
}
export function parseStudioProjectModeForArtifactRegistry(value) {
    return StudioProjectModeV1Schema.parse(value);
}
/** AR-002 — registered artifact metadata with version, integrity, preview, owner. */
export const RegisteredArtifactMetadataV1Schema = z
    .object({
    schemaVersion: z.literal("registered-artifact.v1.0"),
    artifactName: z.string().min(1),
    versionLabel: z.string().min(1),
    integrityRef: z.string().min(1),
    previewRef: EnreinArtifactUriSchema,
    ownerLabel: z.string().min(1),
    builderDeclaration: PerArtifactBuilderDeclarationV1Schema,
})
    .strict();
export function buildRegisteredArtifactMetadata(input) {
    return RegisteredArtifactMetadataV1Schema.parse({
        schemaVersion: "registered-artifact.v1.0",
        artifactName: input.artifactName,
        versionLabel: input.versionLabel,
        integrityRef: input.contentHash,
        previewRef: input.previewUri,
        ownerLabel: input.ownerLabel,
        builderDeclaration: defaultPerArtifactBuilderDeclaration(input.projectMode, input.artifactName),
    });
}
export * from "./artifact-registry-preview.js";
export * from "./artifact-registry-history.js";
export * from "./artifact-registry-diff.js";
export * from "./artifact-registry-external.js";
export * from "./artifact-registry-manifest.js";
export * from "./artifact-registry-invalidation.js";
//# sourceMappingURL=artifact-registry.js.map